import EmitenteSoftwareHouseService from "@/services/EmitenteSoftwareHouseService";

export const emitenteSoftwareHouse = {
  namespaced: true,
  state: {
    emitenteSoftwareHouse: {},
  },
  actions: {
    getEmitenteSoftwareHouse({ commit }, payload) {
      return EmitenteSoftwareHouseService.GetEmitenteSoftwareHouse(
        payload
      ).then(
        (emitenteSoftwareHouse) => {
          return Promise.resolve(emitenteSoftwareHouse);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    postEmitenteSoftwareHouse({ commit }, payload) {
      return EmitenteSoftwareHouseService.PostEmitenteSoftwareHouse(
        payload
      ).then(
        (emitenteSoftwareHouse) => {
          return Promise.resolve(emitenteSoftwareHouse);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    putEmitenteSoftwareHouse({ commit }, payload) {
      return EmitenteSoftwareHouseService.PutEmitenteSoftwareHouse(
        payload
      ).then(
        (emitenteSoftwareHouse) => {
          return Promise.resolve(emitenteSoftwareHouse);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    deleteEmitenteSoftwareHouse({ commit }, payload) {
      return EmitenteSoftwareHouseService.DeleteEmitenteSoftwareHouse(
        payload
      ).then(
        (response) => {
          return Promise.resolve(response);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    getEmitenteSoftwareHouseOData({ commit }, payload) {
      return EmitenteSoftwareHouseService.GetEmitenteSoftwareHouseOData(
        payload
      ).then(
        (emitenteSoftwareHouse) => {
          return Promise.resolve(emitenteSoftwareHouse);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
  },
  mutations: {},
};

export default emitenteSoftwareHouse;
